/**
 * @generated SignedSource<<ec81e7da47cc34d6e54cc01d8a8442da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddressEditSearchMutation$variables = {
  postalCode: string;
};
export type AddressEditSearchMutation$data = {
  readonly postalCode: {
    readonly __typename: "MPostalCode";
    readonly city: string;
    readonly mPrefectureName: string;
    readonly postalCode: string;
    readonly town: string | null;
  } | {
    readonly __typename: "PostalCodeError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AddressEditSearchMutation = {
  response: AddressEditSearchMutation$data;
  variables: AddressEditSearchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postalCode"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "postalCode",
        "variableName": "postalCode"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mPrefectureName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "town",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PostalCodeError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddressEditSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "postalCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "MPostalCode",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddressEditSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "postalCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "MPostalCode",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aaf96d240840ba7bf9ee9ab6824a32dc",
    "id": null,
    "metadata": {},
    "name": "AddressEditSearchMutation",
    "operationKind": "mutation",
    "text": "mutation AddressEditSearchMutation(\n  $postalCode: String!\n) {\n  postalCode(input: {postalCode: $postalCode}) {\n    __typename\n    ... on MPostalCode {\n      postalCode\n      mPrefectureName\n      city\n      town\n      id\n    }\n    ... on PostalCodeError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "204dc47b7e5444e9b39b8d68e8126d6b";

export default node;
